export const environment = {
    production: false,
    overrideUrlsWithBrowserHost: false,
    backendApiUrl: "https://api.test.scrawlbrawl.tv/",
    frontendUrl: "https://test.scrawlbrawl.tv/",
    LANRemoteDebugLogging: false,
    galleryOptions: {
        allowCopy: true,
        allowPaste: true,
    }
};